export default __webpack_public_path__ + "static/media/m_use_action_back3.a38dbf68.png";